/**
 * F16.B+: small SVG flourish that decorates art-deco portal title bars.
 * Stays inert (aria-hidden) and pulls its color from the theme accent so
 * it adapts if the portal's primaryColor overrides the gold default.
 */

import { testIds } from '../../../lib/testIds';

export function ArtDecoOrnament({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      data-testid={testIds.portal.ornament}
      aria-hidden="true"
      viewBox="0 0 60 12"
      width={60}
      height={12}
      className={className}
      // Theme variable will resolve to `--portal-accent` inside the portal
      // subtree; falls back to currentColor when the theme isn't applied
      // (e.g. server-render in tests).
      style={{ color: 'var(--portal-accent, currentColor)' }}
    >
      <path
        d="M0 6 L18 6 L24 1 L30 6 L36 1 L42 6 L60 6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
      />
      <circle cx="30" cy="6" r="1.5" fill="currentColor" />
    </svg>
  );
}
